import { getAreaCodesByAdcode, getAreaName, getDetailAddress } from './locationArea'
import { gcj02PointToWgs84LonLat } from './coordinate'

export function locationPoint(location) {
  if (!location) return null
  const point = typeof location === 'string' ? location.split(',').map(Number) : [Number(typeof location.getLng === 'function' ? location.getLng() : location.lng), Number(typeof location.getLat === 'function' ? location.getLat() : location.lat)]
  return point.length === 2 && point.every(Number.isFinite) && Math.abs(point[0]) <= 180 && Math.abs(point[1]) <= 90 ? point : null
}

export function queryLocationSuggestions(amap, keyword, callback) {
  if (!keyword || !amap) { callback([]); return }
  amap.plugin('AMap.AutoComplete', () => {
    new amap.AutoComplete({ city: '全国', citylimit: false }).search(keyword, (status, result) => {
      if (status !== 'complete' || !result.tips) { callback([]); return }
      callback(result.tips.filter(item => locationPoint(item.location)).slice(0, 10).map(item => ({ value: item.name, name: item.name, context: [item.district, item.address].filter(Boolean).join(' '), location: item.location })))
    })
  })
}

export function reverseLocation(amap, lng, lat) {
  if (!amap) return Promise.resolve(null)
  return new Promise(resolve => {
    new amap.Geocoder().getAddress([lng, lat], (status, result) => {
      if (status !== 'complete' || !result.regeocode) { resolve(null); return }
      const data = result.regeocode
      const areaCodes = getAreaCodesByAdcode((data.addressComponent || {}).adcode, data.addressComponent || {})
      resolve({ lonLat: gcj02PointToWgs84LonLat(lng, lat), areaCodes, areaName: getAreaName(areaCodes), address: getDetailAddress(data.formattedAddress || '', data.addressComponent || {}, areaCodes) })
    })
  })
}
